
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/changelog",
      function () {
        return require("private-next-pages/site/changelog.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/changelog"])
      });
    }
  